import { gql, TypedDocumentNode } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";
import {
  Policy,
  PolicySearchEvaluationRecordsArgs,
  PolicySearchEvaluationRecordSuggestionsArgs,
} from "types/generated";

type SearchPoliciesSamplesData = {
  policy: Policy;
};

export const SEARCH_POLICIES_SAMPLES: TypedDocumentNode<
  SearchPoliciesSamplesData,
  PolicySearchEvaluationRecordsArgs & { id: string }
> = gql`
  query SearchEvaluationRecords($id: ID!, $input: SearchInput!) {
    policy(id: $id) {
      id
      searchEvaluationRecords(input: $input) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            key
            outcome
            timestamp
          }
        }
      }
    }
  }
`;

type SearchPoliciesSuggestionsData = {
  policy: Policy;
};

export const SEARCH_POLICIES_SUGGESTIONS: TypedDocumentNode<
  SearchPoliciesSuggestionsData,
  PolicySearchEvaluationRecordSuggestionsArgs & { id: string }
> = gql`
  query SearchEvaluationRecordSuggestions($id: ID!, $input: SearchSuggestionsInput!) {
    policy(id: $id) {
      id
      searchEvaluationRecordSuggestions(input: $input) {
        ...SearchSuggestionsFragment
      }
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
